export default "/_next/static/images/2020-2x-ee868f5e9d21de28bde642dd6abd06e4.png";